// src/components/UpdateDialog.js
import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, styled } from '@mui/material';
import { useSelector } from 'react-redux';

const CustomHeader = styled(DialogTitle)({
  backgroundColor: '#0A4FAC',
  color: '#fff',
  fontWeight: 'bold',
  fontSize: '16px',
  padding: '8px 16px',
  minHeight: '40px',
  lineHeight: '1.2',
});

const CustomButton = styled(Button)({
  backgroundColor: '#0A4FAC',
  color: '#fff',
  padding: '6px 20px',
  borderRadius: '8px',
  textTransform: 'none',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#0A4FAC',
  },
});

const CenteredActions = styled(DialogActions)({
  justifyContent: 'center',
  borderTop: '1px solid #ccc',
});

const UpdateDialog = ({ open }) => {
  const deviceType = useSelector((state) => state.auth.deviceType); 
  const handlePress = () => {
    const isIOS = deviceType === 'ios';
    const url = isIOS
      ? 'https://apps.apple.com/in/app/gateway-news-network-gnn/id1201724523'
      : 'https://play.google.com/store/apps/details?id=com.gtl.gispm&hl=en-IN';

    isIOS ? window.location.href = url : window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Dialog open={open}>
      <CustomHeader>G•NXT</CustomHeader>
      <DialogContent sx={{ justifyContent: 'center' }}>
        Kindly update your application to access latest features.
      </DialogContent>
      <CenteredActions>
        <CustomButton onClick={handlePress}>Update</CustomButton>
      </CenteredActions>
    </Dialog>
  );
};

export default UpdateDialog;
